<div class="input-group nb-input">
  <div *ngIf="prependIcon" class="input-group-prepend">
    <span class="input-group-text" [innerHTML]="prependIcon"></span>
  </div>
  <input
    [type]="type"
    [ngClass]="{ 'form-control': true, prepend: prependIcon, append: true }"
    [placeholder]="placeholder"
    [ngModel]="value"
    (ngModelChange)="setModel($event)"
  />
  <div class="input-group-append">
    <span *ngIf="appendIcon && !value" class="input-group-text" [innerHTML]="appendIcon"></span>
    <span *ngIf="value" class="input-group-text clear-icon" (click)="clearModel()"><i class="fas fa-times"></i></span>
  </div>
</div>
